import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setUser, setToken, setUserType, setMember } from '../Slices/auth';
import ReactLoading from 'react-loading';
import axios from 'axios';
import toast from 'react-hot-toast';
import mode from './Mode';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import TextField from '@mui/material/TextField';
import '../styles/auth.css';
import Toast from './Toaster';

const Login = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [formMessage, setFormMessage] = useState({ type: '', text: '' });
    const baseurl = mode ? 'https://backend.portal.jkusdachurch.org/general/' : 'http://127.0.0.1:8000/general/';
    const { state } = useLocation();

    const [showPassword, setShowPassword] = useState(false);
    const handleClickShowPassword = () => setShowPassword((show) => !show);
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    useEffect(() => {
        if (state && state.reason) {
            toast.error('Unauthorized, kindly login', {
                duration: 7000,
                position: 'bottom-left'
            });
        }
    }, [state]);

    const onSubmit = () => {
        setIsLoading(true);
        setFormMessage({ type: '', text: '' });
        axios.post(baseurl + 'login/', {
            username: values.email,
            password: values.password
        }).then((response) => {
            dispatch(setUser(response.data.user));
            dispatch(setToken(response.data.token));
            dispatch(setUserType(response.data.userType));
            dispatch(setMember(response.data.member));
            if (response.data.member_exists) {
                toast.success('Login Success');
                setTimeout(() => {
                    if (response.data.userType.includes("Nurturing Admin")) {
                        navigate('/admin-dashboard');
                    } else {
                        navigate('/dashboard');
                    }
                }, 1500);
            } else {
                toast.success('Success. Kindly Complete Registration', {
                    duration: 3000,
                    position: 'bottom-left'
                });
                setTimeout(() => { navigate('/member-register') }, 3000);
            }
        }).catch((err) => {
            setIsLoading(false);
            setFormMessage({ type: 'error', text: 'Invalid credentials. Please try again.' });
        });
    };

    const { values, errors, handleBlur, touched, handleChange, handleSubmit } = useFormik({
        initialValues: {
            email: '',
            password: ''
        },
        onSubmit
    });

    return (
        <div className='auth-container'>
            <Toast />
            <div className="auth-wrapper">
                <div className="auth-header">
                    <h1>Student Login</h1>
                    <p>Welcome back! Please login to your account.</p>
                </div>

                <form method="POST" className='auth-form' onSubmit={handleSubmit}>
                    {formMessage.text && (
                        <div className={`form-message ${formMessage.type}`}>
                            {formMessage.text}
                        </div>
                    )}
                    <div className='form-group'>
                        <label htmlFor="email">Email Address</label>
                        <TextField
                            fullWidth
                            required
                            id="email"
                            variant="outlined"
                            name='email'
                            value={values.email}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            className="form-control"
                        />
                    </div>
                    <div className='form-group'>
                        <label htmlFor="password">Password</label>
                        <TextField
                            fullWidth
                            required
                            id="password"
                            variant="outlined"
                            name='password'
                            type={showPassword ? 'text' : 'password'}
                            value={values.password}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            className="form-control"
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPassword}
                                            onMouseDown={handleMouseDownPassword}
                                            edge="end"
                                        >
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </div>

                    <button className="auth-btn" type="submit" disabled={isLoading}>
                        {isLoading ? <ReactLoading type="spin" color="#fff" height={25} width={25} /> : "Login"}
                    </button>
                </form>
                <div className="auth-footer">
                    <small className="text-muted">
                        Don't have an account? <Link to='/Register'>Sign Up</Link>
                    </small>
                    <br />
                    <small className="text-muted">
                        Forgot your password? <Link to='/reset-give-email'>Reset</Link>
                    </small>
                </div>
            </div>
        </div>
    );
}

export default Login;